var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loginSave"},[_c('img',{staticStyle:{"width":"310px","height":"200px"},attrs:{"src":require("../assets/loginSave.png"),"alt":""}}),_c('p',{staticClass:"demo-loading"},[_vm._v(" 页面跳转中 ")])])
}]

export { render, staticRenderFns }